import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DonutChart } from "../Charts/DonutChart";
import { ChartTypes } from "../Charts/ChartTypes";
import { ChartType } from "chart.js";
import { BarChart } from "../Charts/BarChart";
import { WaterfallChart } from "../Charts/WaterfallChart";

export type ChartRadioButtonProps = {
    type: ChartTypes;
    checked: boolean;
    onClick: (control: ChartRadioButton) => void;
}

export class ChartRadioButton extends JSXComponent {
    props: ChartRadioButtonProps;
    radioButton: SVGSVGElement;

    constructor(props: ChartRadioButtonProps) {
        super(props);
    }

    element: HTMLElement =
        <div className="chart-radio-button">
            <div className="chart-content">
                {this.renderChart()}
            </div>
            <div className="chart-radio">
                {this.renderRadioButton()}
            </div>
        </div>

    renderChart(): SVGSVGElement {
        if (this.props.type == ChartTypes.Donut) {
            return new DonutChart().create([
                { className: "a-chart-blue", value: 5 },
                { className: "a-chart-yellow", value: 2 },
                { className: "a-chart-red", value: 3 }
            ]);
        }
        else if (this.props.type == ChartTypes.Bar) {
            return new BarChart().create([
                { className: "a-chart-blue", value: 5 },
                { className: "a-chart-yellow", value: 10 },
                { className: "a-chart-red", value: 15 }
            ]);
        }
        else if (this.props.type == ChartTypes.Waterfall) {
            return new WaterfallChart().create([
                { className: "a-chart-blue", value: 3 },
                { className: "a-chart-yellow", value: 3 },
                { className: "a-chart-red", value: 3 }
            ]);
        }
        return null;
    }

    renderRadioButton(): SVGSVGElement {
        this.radioButton = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        this.radioButton.setAttribute("width", "100%");
        this.radioButton.setAttribute("height", "100%");
        this.radioButton.setAttribute("viewBox", "0 0 42 42");

        let circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", "21");
        circle.setAttribute("cy", "21");
        circle.setAttribute("r", "15.91549430918954");
        circle.setAttribute("fill", "transparent");
        if (this.props.checked) {
            circle.setAttribute("stroke", "#003E8F");
        }
        else {
            circle.setAttribute("stroke", "#9E9E9E");
        }
        circle.setAttribute("stroke-width", "4");
        this.radioButton.appendChild(circle);

        if (this.props.checked) {
            let inner = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            inner.setAttribute("cx", "21");
            inner.setAttribute("cy", "21");
            inner.setAttribute("r", "8");
            inner.setAttribute("fill", "#003E8F");
            this.radioButton.appendChild(inner);
        }

        return this.radioButton;
    }

    render(): HTMLElement {
        this.element.addEventListener("click", () => {
            this.props.onClick(this);
        });
        return this.element;
    }

    public setCheck(checked: boolean): void {
        this.props.checked = checked;
        let parent = this.radioButton.parentElement;
        parent.removeChild(this.radioButton);
        parent.appendChild(this.renderRadioButton());
    }
}